import type { INavLink, INavLinkGroup } from "@m365-admin/nav";

export const selectLinkAddClick = (
  groups: INavLinkGroup[],
  selectedKey: string,
  callBack: (key: string) => void,
  onExpanded: (key: string) => void,
  expandedKeys: string[],
): INavLinkGroup[] => {
  const processLinks = (links: INavLink[]): INavLink[] => {
    const newLinks = links.map((link: INavLink) => {
      let subLinks;
      if (link.links) {
        subLinks = processLinks(link.links);
      }
      const isSelected = link.key === selectedKey && link.links
        ? link.links?.findIndex(val => val.key === selectedKey) !== -1
        : selectedKey.indexOf(link.url) !== -1;
      const levelText = link.icon ? "Level one menu item" : "Secondary menu item";
      return {
        ...link,
        links: subLinks,
        onClick: () => {
          if (link.onClick) {
            link.onClick();
          }

          if (!link.links) {
            callBack(link.key);
          }
        },
        isSelected,
        ariaLabel: `${levelText} ${link.name} ${isSelected ? "selected." : "not selected."}`,
        isExpanded: link.links && expandedKeys.includes(link.key),
        onExpanded: () => {
          onExpanded(link.key);
        },
      };
    });

    return newLinks;
  };

  const newGroups = groups.map((value: INavLinkGroup) => {
    let newLinks;
    if (value.links) {
      newLinks = processLinks(value.links);

      return { ...value, links: newLinks };
    }

    return { ...value };
  });

  return newGroups;
};
